import {
  Int32FilterItemOutput,
  StringFilterItemOutput,
  FareTypeFilterItemOutput,
  StationOrLocationItem,
  GuidIdCodeAndLabel,
  BrandAndMarketListItemFilterItemOutputWithPermission,
} from '../../../integrated-client/models';
import { IAutocompleteObject } from '../SearchManager/FormData';
import {DEFAULT_PAGE_SIZE, DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IFormData {
  systemContextAgency: GuidIdCodeAndLabel | null
  systemContextAgencyGroup: StringFilterItemOutput | null
  systemContextBrandAndMarket?: BrandAndMarketListItemFilterItemOutputWithPermission | null;
  systemContextChannel: Int32FilterItemOutput | null
  priority: Int32FilterItemOutput | null
  supplier: StringFilterItemOutput | null
  marketingAirline: IAutocompleteObject | null
  fareType: FareTypeFilterItemOutput | null
  id: string | null
  showDisabled: boolean
  showDeleted: boolean
  pageNumber: number
  pageSize: number
  total: number
  origin: StationOrLocationItem | null
  destination: StationOrLocationItem | null
  agencyOnly: boolean | null
  description: string | null
  orderByRelevanceAscending?: boolean
}

export class FormData implements IFormData {
  systemContextAgency: GuidIdCodeAndLabel | null
  systemContextAgencyGroup: StringFilterItemOutput | null
  systemContextBrandAndMarket?: BrandAndMarketListItemFilterItemOutputWithPermission | null;
  systemContextChannel: Int32FilterItemOutput | null
  priority: Int32FilterItemOutput | null
  supplier: StringFilterItemOutput | null
  marketingAirline: IAutocompleteObject | null
  fareType: FareTypeFilterItemOutput | null
  id: string | null
  showDisabled: boolean
  showDeleted: boolean
  pageNumber: number
  pageSize: number
  total: number
  origin: StationOrLocationItem | null
  destination: StationOrLocationItem | null
  agencyOnly: boolean | null
  description: string | null

  constructor() {
    this.systemContextAgency = null;
    this.systemContextAgencyGroup = null;
    this.systemContextBrandAndMarket = null;
    this.systemContextChannel = null;
    this.priority = null;
    this.supplier = null;
    this.marketingAirline = null;
    this.fareType = null;
    this.id = null;
    this.origin = null;
    this.destination = null;
    this.agencyOnly = null;
    this.showDisabled = false;
    this.showDeleted = false;
    this.description = null;
    this.pageNumber = 1;
    this.pageSize = DEFAULT_PAGE_SIZE;
    this.total = DEFAULT_TOTAL_ITEMS
  }

}
